import { IResourcePermission } from "@gettactic/api";
import { LockClosedIcon } from "@heroicons/react/outline";
import { UsersIcon } from "@heroicons/react/solid";
import { UserCell } from "@gettactic/components/src/components/WeeklyOffice/cells/UserCell";
import { TacticTooltip } from "@/ui/index";

type Props = {
    permission: IResourcePermission;
};

export function PermissionCell({ permission }: Props) {
    const { user, team } = permission;
    return user ? (
        <div className="flex flex-nowrap items-center gap-2 border-l border-l-gray-300 py-2 pl-3">
            <div className="shrink-0">
                <TacticTooltip
                    reference={
                        <UserCell row={{ original: { user } }} isMe={false} hasAnyFav={false} />
                    }
                    stateProps={{
                        placement: "top"
                    }}
                >
                    <p className="text-sm max-w-[300px] font-bold text-black min-w-0 flex-1 break-words">
                        {user.name}
                    </p>
                </TacticTooltip>
            </div>
        </div>
    ) : team ? (
        <div className="flex flex-nowrap items-center gap-2 border-l border-l-gray-300 py-2 pl-3">
            <div className="rounded-full bg-secondary-hover p-1.5 shrink-0">
                <UsersIcon className="h-4 w-4 text-white" />
            </div>
            <h6 className="text-sm font-bold text-tertiary truncate min-w-0 flex-1">
                {team.name}
            </h6>
            {team.is_hidden ? (
                <TacticTooltip
                    reference={
                        <div className="flex items-center rounded-2xl bg-amber-50 px-2 text-xs text-amber-500 shrink-0">
                            <LockClosedIcon className="h-4 w-4" />
                        </div>
                    }
                    stateProps={{
                        placement: "top"
                    }}
                >
                    <p className="text-base text-amber-500">Hidden</p>
                </TacticTooltip>
            ) : null}
        </div>
    ) : null;
}
